export default Object.freeze({
  "360": "360",
  "300": "300",
  "240": "240",
  "180": "180",
  "120": "120",
  "84": "84"
});
